import exclamationIcon from "../../../../../assets/shared/exclamation_circle_grey.svg";
import {
  ManageStudiesActionType,
  useManageStudiesContext,
} from "../../../../../context/ManageStudiesContext";
import { IStudyTreeItem } from "../../../../../models/study.interface";
import { BaseIcon } from "@shltelemedicine/shl-ui-lib";
import NoDataIndicator from "../../../../Shared/NoDataIndicator/NoDataIndicator";
import StudyIcon from "../../../../Shared/StudyIcon/StudyIcon";
import { ManagementHeaderDivider } from "../../../ManagementHeader/ManagementHeader";
import UsersCount from "../../../ManagementHeader/UsersCount/UsersCount";
import SubjectsCount from "../../SubjectsCount/SubjectsCount";
import StudyActions from "./StudyActions/StudyActions";
import styles from "./TreeStudyItem.module.css";

type TreeStudyItemProps = { item: IStudyTreeItem };

const TreeStudyItem = ({ item }: TreeStudyItemProps) => {
  const { dispatch } = useManageStudiesContext();
  const {
    name,
    reference,
    totalLinkedUsers,
    totalActiveLinkedUsers,
    totalSubjects,
  } = item;

  const linkUsersClickedHandler = () => {
    setSelectedStudy();

    dispatch({
      type: ManageStudiesActionType.SET_LINK_USERS_MODAL,
      payload: true,
    });
  };

  const editStudyClickedHandler = () => {
    setSelectedStudy();

    dispatch({
      type: ManageStudiesActionType.SET_STUDY_MODAL,
      payload: {
        mode: "edit",
        show: true,
      },
    });
  };

  const deleteStudyClickedHandler = () => {
    setSelectedStudy();

    dispatch({
      type: ManageStudiesActionType.SET_DELETE_STUDY_MODAL,
      payload: true,
    });
  };

  const setSelectedStudy = () => {
    dispatch({
      type: ManageStudiesActionType.SET_SELECTED_STUDY,
      payload: item,
    });
  };

  return (
    <>
      <div className={`d-flex algin-items-center ${styles.studyName}`}>
        <StudyIcon size="sm" className="mx-sm" />
        <span className="mx-1"></span>
        <span className="cut-text">{name}</span>
      </div>
      <div className="d-flex flex-grow-1 justify-content-lg-end mx-3 mx-lg-0">
        <div className={`${styles.reference} d-flex align-items-center`}>
          <BaseIcon icon={exclamationIcon} className={styles.exclamationIcon} />
          <span className="mx-1 cut-text">
            {reference ?? <NoDataIndicator />}
          </span>
        </div>
      </div>
      <div
        className={`${styles.actions} d-flex align-items-center justify-content-end`}
      >
        <UsersCount
          total={totalLinkedUsers}
          active={totalActiveLinkedUsers}
          inactive={totalLinkedUsers - totalActiveLinkedUsers}
        />
        <ManagementHeaderDivider className="mx-3" />
        <SubjectsCount total={totalSubjects} />
        <span className="mx-2"></span>
        <StudyActions
          onLinkUsers={linkUsersClickedHandler}
          onEditStudy={editStudyClickedHandler}
          onDeleteStudy={deleteStudyClickedHandler}
          hideDelete={!!totalLinkedUsers}
        />
      </div>
    </>
  );
};

export default TreeStudyItem;
